















import ContractHistoryLayer from '@/components/partner/ContractHistoryLayer.vue';

interface ContractsEntryContracts {
	contractContents: string;
	changeReason: string;
}

import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import {
	Contracts,
	ContractsEditInfo,
} from 'supporter';
import {ncpPopup} from '@/utils/ncp';
import {toI18n} from '@/utils/commonUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import { GridEventProps } from 'tui-grid/types/event';
@Component({
	components: {
		ItemTable,
    ContractHistoryLayer
	}
})
export default class MallsContractsGrid extends Vue {
	@Prop({required: true})
	readonly contractsInfo: Contracts;
	@Prop({required: true})
	readonly postContractsRequestData: ContractsEditInfo[];
	@Prop({required: true})
	readonly postEntryContractsRequestData: ContractsEntryContracts;
	@Prop({required: true})
	readonly partnerStatus: {[index: string]: {key:string, value:boolean}};
	@Prop({required: true})
	readonly entryContracts: [{contractNo: string, agreeWithStandingPointContract: boolean}];

  @Ref()
  private readonly gridRef: ItemTable;
	private status = this.partnerStatus;
	private useDefaultCommissionRateStatus: boolean = false;
	private showContractHistoryLayer: boolean  = false;
  private selectedMallNo: number = 0;

	private option = {
		noBorder: true,
		showTopcontent: false,
	}
	private gridProps = {
		noBorder: true,
		columns: [
			{
				// 쇼핑몰 명
				header: this.$t('PARTNER_EDIT_MALL_NAME'),
				name: 'mallName',
				align: 'center',
				minWidth: 179,
			},
			{
				// 담당MD
				header: this.$t('PARTNER_EDIT_CHARGE_MD_NAME'),
				name: 'chargeMdName',
				align: 'center',
				minWidth: 119,
				renderer: ({grid, rowKey}:any) => {
         	 	const row = grid.getRow(rowKey);
	          const div = document.createElement('div');
            const span = document.createElement('span');
            const btn = document.createElement('button');
						const url = `/partner/popup/change-md?mallNo=${row.mallNo}&chargeMdNo=${row.merchandiserNo}&partnerNo=${row.partnerNo}&commissionRate=${row.commissionRate}&contractNo=${row.contractNo}&promotionAgreed=${row.promotionAgreed}`;
            span.innerText = ' ' + row.merchandiserName; //버튼과 텍스트 사이 공백 유지
						btn.innerText = this.$t('PARTNER_EDIT_CHANGE') as string;
          	btn.type = 'button';
						const handleChangeMdClick = () => {ncpPopup(url, window.$t('PARTNER_EDIT_CHANGE_ADMIN'), 736, 550)}
            btn.addEventListener('click', handleChangeMdClick);
          	div.append(btn, span);

            return {
              getElement(): any {
                return div;
              },
              render(): any {
                div.append(btn, span);
              },
            };
          }
			},
			//기본 수수료 사용
			{
				header: this.$t('PARTNER_EDIT_USE_DEFAULT_COMMISSION_RATE'),
				name: 'useDefaultCommissionRate',
				align: 'center',
				minWidth: 179,
				formatter: ({row}: any): string => {
					const $commissionRateEl = `<div class="tui-grid-cell-content" style="white-space:nowrap;max-height:35px">
																			${row.usesDefaultCommissionRate
																			? this.useDefaultCommissionRateOptions[0].text
																			: this.useDefaultCommissionRateOptions[1].text}
																		</div>`;
					const getCommissionRateRadioHTML = option => `<input
																						data-contract-no="${row.contractNo}"
																						class="usesDefaultCommissionRate"
																						type="${option.type}"
																						name="${option.name}_${row.mallName}"
																						id="${option.id}"
																						value="${option.value}"
																						${option.value === row.usesDefaultCommissionRate && 'checked'}
																					>
																					<label for="${option.id}">${option.text}</label>`
					if(this.status.WAITING.value) return $commissionRateEl
					return this.useDefaultCommissionRateOptions.map(option => getCommissionRateRadioHTML(option)).join('')
				},
			},
			// 수수료율
			{
				header: this.$t('PARTNER_EDIT_COMMISSION_RATE'),
				name: 'commissionRate',
				align: 'center',
				validation: {
					dataType: 'number',
				},
				minWidth: 104,
				formatter: ({row}: any): string => {
					if(this.status.WAITING.value) return `
						<span
							style="width: 50px;
							text-align: center;"
							class="ncp_input"
						>${row.commissionRate}<span> %</span></span>`
					return `<input
										data-contract-no="${row.contractNo}"
										type="text"
										name="commissionRate"
										class="commissionRate"
										style="width: 50px;
										text-align: center;"
										data-limit="2"
										data-digits="1"
										value="${row.usesDefaultCommissionRate ? row.commissionRate : row.pureCommissionRate}"
										${row.usesDefaultCommissionRate ? '' : 'disabled'}
									><span> %</span>`
				}
			},
			// 프로모션동의
			{
				header: this.$t('PARTNER_EDIT_AGREE_PROMOTION'),
				name: 'promotionAgreed',
				align: 'center',
				minWidth: 179,
				formatter: ({row}): string => {
					if(this.status.WAITING.value) return `<div
																									class="tui-grid-cell-content"
																									style="white-space:nowrap;max-height:35px"
																								>
																									${this.useDefaultCommissionRateStatus
																									? this.promotionAgreedOptions[0].text
																									: this.promotionAgreedOptions[1].text}
																								</div>`
					return this.promotionAgreedOptions.map(option => {
						return (
							`<input
									data-contract-no="${row.contractNo}"
									type="${option.type}"
									name="${option.name}_${row.mallName}"
									id="${option.id}"
									value="${option.value}"
									class="promotionAgreed"
									${option.value === row.promotionAgreed && 'checked'}
								>
								<label for="${option.id}">${option.text}</label>`
						)
					}).join('')
				}
			},
			// 거래상태
			{
				header: this.$t('PARTNER_EDIT_CONTRACT_STATUS'),
				name: 'contractStatus',
				align: 'center',
				minWidth: 179,
				formatter: ({row, value}) => {
					//ß
					if(this.status.WAITING.value) {
						return this.$t(`PARTNER_EDIT_${value}`) as string
					}
					if(row.contractStatus === 'INVESTIGATION' || this.status.INVESTIGATION.value) {
						return `<div class="btn_wrap no_margin approvalBtns">
											<button type="button" id="btn_approval" name="approval" data-contract-no="${row.contractNo}">
												${this.$t('PARTNER_EDIT_APPROVAL')}
											</button>
											<button type="button" id="btn_disapproval" name="disapproval" data-contract-no="${row.contractNo}">
												${this.$t('PARTNER_EDIT_DISAPPROVAL')}
											</button>
										</div>`
					}
					if(this.status.WAITING.key === row.contractStatus) {
						return `<div
											class="no_margin"
										>${this.$t('PARTNER_EDIT_WAITING')} /
											<button
												type="button"
												class="grid_btn_resend"
												data-contract-no="${row.contractNo}"
											>${this.$t('PARTNER_EDIT_RESEND_EMAIL')}
											</button>
										</div>`
					}

          if (row.contractStatus === 'SUSPEND'){
            return `${this.$t(`PARTNER_EDIT_${value}`)}  <button type="button" class="grid_btn_unsuspend" data-contract-no="${row.contractNo}">${this.$t('PARTNER_EDIT_UNSUSPEND')}</button>`
          }

					if (this.status.ACTIVE.value || row.contractStatus === 'ACTIVE') {
            return `${this.$t(`PARTNER_EDIT_${value}`)}  <button type="button" class="grid_btn_suspend" data-contract-no="${row.contractNo}">${this.$t('PARTNER_EDIT_SUSPEND')}</button>`
					}

					return this.$t(`PARTNER_EDIT_${value}`) as string
				}
			},
      //계약서류
			{
				header: this.$t('PARTNER_EDIT_CONTRACT_FILE'),
				name: 'contractFile',
				align: 'center',
				minWidth: 89,
				formatter: ({ row }: any) => {
					const hyphenTextHtml = '<div class="tui-grid-cell-content contractNo" style="white-space:nowrap;">-</div>'
					if(this.status.WAITING.value) return hyphenTextHtml
					if(this.status.WAITING.key === row.contractStatus) return hyphenTextHtml

          const contractStatus = this.status.ACTIVE.key === row.contractStatus ? `${this.$t('PARTNER_EDIT_CHECK_CONTRACT')} / ${this.$t('PARTNER_EDIT_CHANGE')}` : this.$t('PARTNER_EDIT_CHECK_CONTRACT');
					return `<a
										href="javascript:window.open('/partner/popup/contract-files?mallNo=${row.mallNo}&contractNo=${row.contractNo}&contractStatus=${row.contractStatus}', '_blank', 'width=550, height=500');"
									>
										${contractStatus}
                  </a>`;
				}
			},
      //계약 서류 변경이력
      {
        header: this.$t('PARTNER_EDIT_CONTRACT_FILE_UPDATE_HISTORY'),
        name: 'contractFilesUpdateHistory',
        align: 'center',
        minWidth: 130,
        formatter: ({ row }: any) => {
          const hyphenTextHtml = '<div class="tui-grid-cell-content contractNo" style="white-space:nowrap;">-</div>'
          if (this.status.WAITING.key === row.contractStatus || this.status.INVESTIGATION.key === row.contractStatus) {
            return hyphenTextHtml;
          }

          return `<span class="history-view">
										${this.$t('PARTNER_EDIT_CHECK_CONTRACT')}
                  </span>`;
        }
      },
			//입점 계약서
			{
				header: this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT'),
				name: 'standingPointContract',
				align: 'center',
				minWidth: 179,
				formatter: ({row}: any) => {
					const hyphenTextHtml = '<div class="tui-grid-cell-content contractNo" style="white-space:nowrap;">-</div>';
					// let agreeWithStandingPointContract;
					(window as any).standingPointContractPopupCallback = this.standingPointContractPopupCallback;
					if(this.status.WAITING.value) return hyphenTextHtml;
					if(this.status.WAITING.key === row.contractStatus) {
						return hyphenTextHtml;
					} else if(this.status.INVESTIGATION.key === row.contractStatus) {
						const standingPointContractBtnHtml = `<a
																										href="javascript:window.open('/contract/standingPointContract/popup?mallNo=${row.mallNo}&contractNo=${row.contractNo}&type=history', '_blank', 'width=1000, height=700');"
																									>${this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT_POPUP')}
																									</a>`
						if(row.latestEntryContractAgreed === true) {
							//계약내용보기
							return standingPointContractBtnHtml;
						}

						//사용안함
						return this.toI18n('PARTNER_EDIT_NO_USE')
					} else if(this.status.ACTIVE.key === row.contractStatus) {
						//@DONE: mallNo, contractNo 를 쿼리로 전달 & callback 데이터 받을 수 있도록 standingPointContractPopupCallback 구현
						//계약등록
						const standingPointContractRegisterBtnHtml = `<a
																														href="javascript:window.open('/contract/standingPointContract/popup?mallNo=${row.mallNo}&contractNo=${row.contractNo}&type=register&callback=standingPointContractPopupCallback', '_blank', 'width=1000, height=700');"
																													>${this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT_ADD')}
																													</a>`;
						//계약등록취소
						const standingPointContractCancelBtnHtml = `<a
																													href="javascript:window.open('/contract/standingPointContract/popup?mallNo=${row.mallNo}&contractNo=${row.contractNo}&type=registerCancel&callback=standingPointContractPopupCallback', '_blank', 'width=1000, height=700');"
																												>${this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT_CANCEL')}
																												</a>`;
						//계약내용보기
						const standingPointContractInquiryBtnHtml = `<a
																														href="javascript:window.open('/contract/standingPointContract/popup?mallNo=${row.mallNo}&contractNo=${row.contractNo}&type=history', '_blank', 'width=1000, height=700');"
																													>${this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT_POPUP')}
																													</a>`;
						//계약내용변경
						const standingPointContractChangeBtnHtml = `<a
																													href="javascript:window.open('/contract/standingPointContract/popup?mallNo=${row.mallNo}&contractNo=${row.contractNo}&type=modification&callback=standingPointContractPopupCallback', '_blank', 'width=1000, height=700');"
																												>${this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT_CHANGE')}
																												</a>`;
						//계약내용변경취소
						const standingPointContractChangeCancelBtnHtml = `<a
																																href="javascript:window.open('/contract/standingPointContract/popup?mallNo=${row.mallNo}&contractNo=${row.contractNo}&type=cancel&callback=standingPointContractPopupCallback', '_blank', 'width=1000, height=700');"
																															>${this.$t('PARTNER_EDIT_STANDING_POINT_CONTRACT_CHANGE_CANCEL')}
																															</a>`;
						// this.entryContracts.forEach(info => agreeWithStandingPointContract = info.contractNo === `${row.contractNo}` && info.agreeWithStandingPointContract)

						// 입점 계약서 사용
						if(!row.entryContractSize) {
							//사용안함/계약등록
							return `<div class="no_margin">${this.$t('PARTNER_EDIT_NO_USE')} / ${standingPointContractRegisterBtnHtml}</div>`
						}
						if(row.entryContractSize === 1 && !row.latestEntryContractAgreed) {
							//사용안함/계약등록취소
							return `<div class="no_margin">${this.$t('PARTNER_EDIT_NO_USE')} / ${standingPointContractCancelBtnHtml}</div>`
						}
						if(row.latestEntryContractAgreed) {
							// 계약내용보기/계약내용변경
							return `<div class="no_margin">${standingPointContractInquiryBtnHtml} / ${standingPointContractChangeBtnHtml}</div>`;
						}
						// 계약내용보기/계약내용변경취소
						return `<div  class="no_margin">${standingPointContractInquiryBtnHtml} / ${standingPointContractChangeCancelBtnHtml}</div>`;
					}
					return hyphenTextHtml;
				}
			},
			{
				header: this.$t('PARTNER_EDIT_START_YMDT'),
				name: 'startedDateTime',
				align: 'center',
				minWidth: 149,
				formatter: ({value}) => `${value ? value : ''}`
			},
			{
				header: this.$t('PARTNER_EDIT_EXTERNAL_API_KEY'),
				name: 'externalApiKey',
				align: 'center',
				minWidth: 147,
				formatter: ({value, row}) => {
					if(this.status.WAITING.value) return '<div class="tui-grid-cell-content" style="white-space:nowrap;"></div>'
					if(this.status.WAITING.key === row.contractStatus) return ''
					return value
				}
			},
			{
				header: this.$t('COMMON_DELETE'),
				name: 'delete',
				align: 'center',
				minWidth: 60,
				renderer: ({grid, rowKey}: any) => {
          const { contractNo, contractStatus } = grid.getRow(rowKey) as Contracts;

          const cellEl = document.createElement('div');
          cellEl.className = 'tui-grid-cell-content';

          if (this.status.ACTIVE.value && ['WAITING', 'INVESTIGATION'].includes(contractStatus)) {
            const deleteBtn = document.createElement('a');
            deleteBtn.href = 'javascript:;';
            deleteBtn.className = 'underline';
            deleteBtn.textContent = this.$t('COMMON_DELETE') as string;

            deleteBtn.addEventListener('click', () => {
              if (!confirm(this.$t('PARTNER_EDIT_CONFIRM_DELETE_MALL') as string)) {
                return;
              }

              this.$api.deleteContract({
                contractNo,
              })
                .then(() => {
                  this.$emit('reloadContracts');
                });
            });

            cellEl.append(deleteBtn);
          } else {
            cellEl.append('-');
          }

          return {
            getElement(): any {
              return cellEl;
            },
          };
        },
			},
		],
		options: {
			rowHeaders: ['rowNum'],
			header: {
				height: 28
			},
			columnOptions: {
				minWidth: 31,
				resizable: true
			},
			minRowHeight: 20,
			isInitialRequest: true,
			keyColumnName: 'contractNo'
		},
	}
	// 기본수수료 사용 라디오 옵션
	private useDefaultCommissionRateOptions = [
		{
			type: 'radio',
			id: 'usesDefaultCommissionRate_true',
			name: 'usesDefaultCommissionRate',
			value: true,
			text: this.$t('PARTNER_EDIT_USE')
		},
		{
			type: 'radio',
			id: 'usesDefaultCommissionRate_false',
			name: 'usesDefaultCommissionRate',
			value: false,
			text: this.$t('PARTNER_EDIT_NO_USE')
		}
	];
	// 프로모션동의 라디오 옵션
	private promotionAgreedOptions = [
		{
			type: 'radio',
			name: 'promotionAgreed',
			id: 'promotionAgreed_Y',
			value: true,
			text: this.$t('PARTNER_EDIT_AGREED'),
		},
		{
			type: 'radio',
			name: 'promotionAgreed',
			id: 'promotionAgreed_N',
			value: false,
			text: this.$t('PARTNER_EDIT_DISAGREED'),
		},
	];

	private toI18n(needToI18nStr: string): string {
		return toI18n(this.$t(needToI18nStr));
	}

	// 하단은 입점계약 팝업 관련 내용
	private standingPointContractPopupCallback(contractContent: HTMLElement): void {
		this.tempTestData.text = contractContent;
		/*
		* TODO: 팝업 개발 후 확인 필요
		* 현재는 입점계약서에서 텍스트 입력 후 저장을 누르면 해당 컨텐츠가 인자로 넘어오도록 구현되어 있음.
		* */
		this.$emit('reloadContracts')
	}
	private tempTestData = {
		text: undefined
	}


  private onItemClicked({ rowKey, columnName }: GridEventProps) {
    const rowData = this.gridRef.getRow(rowKey);

    if (columnName === 'contractFilesUpdateHistory') {
      this.showContractHistoryLayer = true;
      this.selectedMallNo = Number(rowData.mallNo);
    }
  }
}
